//messages.js
export default {
    tank_manufacturers: "Fabricantes de tanques",
    tank_manufacturer: "Fabricante de tanques",
    delete_tank_manufacturer: "Eliminar fabricante de tanques",
    add_tank_manufacturer: "Agregar fabricante de tanques",
    edit_tank_manufacturer: "Editar fabricante de tanques",
    manufacturer: "Fabricante",
    phone: "Teléfono",
    tank_name: "Nombre del tanque",
    def_us_gallons: "Galones usd por defecto",
    metric_diameter: "Diámetro métrico",
    metric_height: "Altura métrica",
    metric_width: "Ancho métrico",
    metric_length: "Longitud métrica",
    tank_manufacturers_specs: "Especificaciones de fabricantes de tanques",
    delete_tank_manufacturers_spec: "Eliminar especificación de fabricantes de tanques",
    add_tank_manufacturers_spec: "Agregar especificación de fabricantes de tanques",
    edit_tank_manufacturers_spec: "Editar especificación de fabricantes de tanques",
};
